import React from "react"
import { injectIntl, Link } from "gatsby-plugin-intl"
import Img from "gatsby-image"

const ImageHighlight = ( { image, domain, intl } ) => (
  <div className="highlight image hidden">
    <Link to={ `/cases/${ domain }` }>
      <Img fluid={ image.childImageSharp.fluid } />
      <div className="caption">
        <b>{ intl.formatMessage( { id: `highlights.${ domain }.name` } ) }</b>
        { intl.formatMessage( { id: `highlights.${ domain }.text` } ) }
      </div>
    </Link>
  </div>
)

const injected = injectIntl( ImageHighlight );
export { injected as ImageHighlight }
